import { ETelemetryTopOf, IUsageTop, IUsageTopElement } from 'multirpc-sdk';

const fallback: IUsageTopElement[] = [];

export interface IGetTopElementsByIDParams {
  id: ETelemetryTopOf;
  tops: IUsageTop[];
}

export const getTopElementsById = ({ id, tops }: IGetTopElementsByIDParams) => {
  const top = tops.find(({ top_of }) => top_of === id);

  return top?.elements ?? fallback;
};
